import { Row } from '@/stories/organisms/Grid/Row';
import { Button } from '@/stories/atoms/Button/Button';

import { getRoute } from '@/utils/utils';
import { LocalitySearch } from '@/stories/components/Form/LocalitySearch/LocalitySearch';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { FormWrapper } from '@/stories/components/Form/Form';
import { useEstimateFormStore } from './useEstimateFormStore';
import { CommuneEntity } from '@/utils/geo-search';

import styles from './search-module.module.css'

export const EstimatePanel = ({
  estimLoc,
  estimBuy
}: {
  estimLoc: boolean
  estimBuy: boolean
}) => {
  const { locality, type, setType, setLocality} = useEstimateFormStore()

  return (
    <FormWrapper action={getRoute({key: 'estimate'})}>
      <Row className={styles.form} sDirectionCol>
        {(estimBuy && estimLoc) && (
          <Row sDirectionCol>
            <Button
              type='button'
              variant={type === 'sell' ? 'secondary' : 'primary'}
              onClick={() => setType('sell')}
              active={type === 'sell'}
              >Prix de vente</Button>
            <Button
              type='button'
              variant={type === 'rent' ? 'secondary' : 'primary'}
              onClick={() => setType('rent')}
              active={type === 'rent'}
              >Montant du loyer</Button>
          </Row>
        )}
        <LocalitySearch
          className={styles.field}
          localityTypes={['commune', 'departement', 'arrondissement']}
          excludeArrondissementCities
          localities={locality ? [locality] : []}
          setLocalities={(localities) => {
            setLocality(localities[0] as CommuneEntity)
          }}
          label={'Ou cherchez-vous ?'}
          variant='secondary'
          hideLabel
          />
        <Button className={styles.submit} type='submit' rounded><><span className='sr-only-md'>Rechercher</span> <Icon icon='search'/></></Button>
      </Row>
    </FormWrapper>
  )
};
